var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Devolu\\xE7\\xF5es_e_Cancelamentos",
    "data-name": "Devolu\\xE7\\xF5es e Cancelamentos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.622,
    height: 47.622,
    viewBox: "0 0 47.622 47.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1029",
    "data-name": "Caminho 1029",
    d: "M6.8,32A6.809,6.809,0,0,0,0,38.8V72.819a6.809,6.809,0,0,0,6.8,6.8H40.819a6.809,6.809,0,0,0,6.8-6.8V38.8a6.809,6.809,0,0,0-6.8-6.8Zm9.354,21.26H31.464a2.551,2.551,0,1,1,0,5.1H16.157a2.551,2.551,0,1,1,0-5.1Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.8da304e1b6c75196b2943cc281cc1b23.svg";
export { ForwardRef as ReactComponent };